import React from 'react';
import ReactSelect from 'react-select';
import ReactAsyncSelect from 'react-select/async';
import { withTheme } from 'styled-components';

function SelectComponent(properties) {
  const { theme } = properties;

  return (
    <ReactSelect
      styles={theme.selectStyle}
      theme={(provided) => ({
        ...provided,
        colors: {
          ...provided.colors,
          primary: theme.palette.primary,
        },
      })}
      {...properties}
    />
  );
}

function AsyncSelectComponent(properties) {
  const { theme } = properties;
  return (
    <ReactAsyncSelect
      styles={theme.selectStyle}
      theme={(provided) => ({
        ...provided,
        colors: {
          ...provided.colors,
          primary: theme.palette.primary,
        },
      })}
      {...properties}
    />
  );
}

const Select = withTheme(SelectComponent);
const AsyncSelect = withTheme(AsyncSelectComponent);

export { Select, AsyncSelect };
